/* Plumeria Maison Luxe : apparitions au défilement, curseur laiton, ajout d'un look complet au panier. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = document.documentElement.classList.contains('shopify-design-mode');

  /* 1. Apparition douce des titres et des cartes */
  function initReveal(root) {
    if (reduceMotion || designMode || !('IntersectionObserver' in window)) return;
    var targets = (root || document).querySelectorAll(
      '[data-luxe-reveal], .luxe-section .luxe-head, #MainContent .product-card'
    );
    if (!targets.length) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    /* Dans un carrousel (défilement horizontal), l'animation ferait sauter les cartes pendant le glissement */
    function inCarousel(el) {
      if (el.closest('slideshow-slides, slideshow-component')) return true;
      for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
        var ox = getComputedStyle(p).overflowX;
        if (ox === 'auto' || ox === 'scroll') return true;
      }
      return false;
    }
    targets.forEach(function (el) {
      if (el.classList.contains('luxe-reveal')) return;
      if (inCarousel(el)) return;
      /* Ce qui est déjà à l'écran au chargement reste visible tout de suite */
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9) return;
      el.classList.add('luxe-reveal');
      observer.observe(el);
    });
  }

  /* 2. Curseur : un cercle laiton qui suit la souris et grossit sur les éléments cliquables */
  function initCursor() {
    if (reduceMotion || designMode) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var cursor = document.createElement('div');
    cursor.className = 'luxe-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cursor);

    var x = 0, y = 0, frame = null;
    function paint() {
      cursor.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
      frame = null;
    }
    document.addEventListener('mousemove', function (e) {
      x = e.clientX;
      y = e.clientY;
      cursor.classList.add('is-active');
      if (!frame) frame = requestAnimationFrame(paint);
    }, { passive: true });
    document.addEventListener('mouseleave', function () {
      cursor.classList.remove('is-active');
    });
    document.addEventListener('mouseover', function (e) {
      var interactive = e.target.closest && e.target.closest('a, button, [role="button"], label, summary, .product-card');
      cursor.classList.toggle('is-large', !!interactive);
    }, { passive: true });
  }

  /* 3. « Acheter le look » : ajoute toutes les pièces du look puis ouvre le panier latéral */
  function initLooks() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-luxe-look-add]');
      if (!button || button.disabled) return;
      event.preventDefault();
      var ids = (button.dataset.luxeLookAdd || '').split(',').filter(Boolean);
      if (!ids.length) return;
      var label = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Ajout en cours…';
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; })
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'luxe-look', data: { source: 'luxe-look', itemCount: cart.item_count } }
          }));
          button.textContent = 'Ajouté au panier';
          setTimeout(function () { button.innerHTML = label; button.disabled = false; }, 2500);
        })
        .catch(function () {
          button.textContent = 'Un bijou est épuisé : voir les pièces';
          button.disabled = false;
        });
    });
  }

  function init() {
    initReveal();
    initCursor();
    initLooks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
})();
